export default "__VITE_ASSET__73d25bd0__"